import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=66512001&scoped=true&"
import script from "./realName.vue?vue&type=script&lang=js&"
export * from "./realName.vue?vue&type=script&lang=js&"
import style0 from "./realName.vue?vue&type=style&index=0&id=66512001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66512001",
  null
  
)

export default component.exports